<template>
  <h1>404</h1>
  <p>Here is one of many pages that does not exist yet.</p>
  <p>Most pages do not exist.</p>
  <p></p>
</template>


<script>
export default {
}
</script>

<style>
p {
  text-align: left;
  margin: 20px;
  padding: 4px;
}
</style>